import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import { notification } from 'antd';
import STActions, { stActionTypes } from '@Actions/stActions';
import TrackerActions from '@Actions/trackerActions';
import STService from '@Services/stServices';

/**
 * @param action
 */
function* _createSt(action) {
  try {
    yield put(STActions.createStLoading(true));
    const st = yield STService.createSt(action.payload);
    if (st.success) {
      yield put(TrackerActions.trackAction(stActionTypes.CREATE_ST.SUCCESS, st.data));
      notification.open({
        type: 'success',
        message: 'Created stock transfer request successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: st.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(STActions.createStLoading(false));
  } catch (error) {
    yield put(STActions.createStLoading(false));
    yield put(TrackerActions.trackAction(stActionTypes.CREATE_ST.ERROR, error));
  }
}

/**
 *
 */
function* createSt() {
  yield takeLatest(stActionTypes.CREATE_ST.REQUEST, _createSt);
}

/**
 * @param action
 */
function* _updateSt(action) {
  try {
    yield put(STActions.updateStLoading(true));
    const st = yield STService.updateSt(action.payload);
    if (st.success) {
      yield put(TrackerActions.trackAction(stActionTypes.UPDATE_ST.SUCCESS, st.data));
      notification.open({
        type: 'success',
        message: 'Updated Stock Transfer successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: st?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(STActions.updateStLoading(false));
  } catch (error) {
    yield put(STActions.updateStLoading(false));
    yield put(TrackerActions.trackAction(stActionTypes.UPDATE_ST.ERROR, error));
  }
}

/**
 *
 */
function* updateSt() {
  yield takeLatest(stActionTypes.UPDATE_ST.REQUEST, _updateSt);
}

/**
 * @param action
 */
function* _updateStStatus(action) {
  try {
    yield put(STActions.updateStStatusLoading(true));
    const st = yield STService.updateStStatus(action.payload);
    if (st.success) {
      notification.open({
        type: 'success',
        message: 'Updated Stock Transfer status successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: st?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(STActions.updateStStatusLoading(false));
  } catch (error) {
    yield put(STActions.updateStStatusLoading(false));
    yield put(TrackerActions.trackAction(stActionTypes.UPDATE_ST_STATUS.ERROR, error));
  }
}

/**
 *
 */
function* updateStStatus() {
  yield takeLatest(stActionTypes.UPDATE_ST_STATUS.REQUEST, _updateStStatus);
}

/**
 * @param action
 */
function* _getSt(action) {
  try {
    yield put(STActions.getStLoading(true));
    const {
      tenantId, stId, page, limit, searchKeyword, receivingStatus, status, department, callback,
    } = action;
    const st = yield STService.getSt(
      tenantId, stId, page, limit, searchKeyword, receivingStatus, status, department,
    );
    yield put(STActions.getStSuccess(st));
    yield put(STActions.getStLoading(false));
  } catch (error) {
    yield put(STActions.getStLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stActionTypes.GET_ST.ERROR, error));
  }
}

/**
 *
 */
function* getSt() {
  yield takeLatest(stActionTypes.GET_ST.REQUEST, _getSt);
}

/**
 * @param action
 */
function* _getStById(action) {
  try {
    yield put(STActions.getStByIdLoading(true));
    const st = yield STService.getSt(action.tenantId, action.stId, 1);
    yield put(STActions.getStByIdSuccess(st?.result?.stock_transfers?.[0]));
    yield put(STActions.getStByIdLoading(false));
  } catch (error) {
    yield put(STActions.getStByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(stActionTypes.GET_ST_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getStById() {
  yield takeLatest(stActionTypes.GET_ST_BY_ID.REQUEST, _getStById);
}

/**
 * @param action
 */
function* _deleteSt(action) {
  try {
    yield put(STActions.deleteStLoading(true));
    const st = yield STService.deleteSt(action.payload);
    if (st.success) {
      notification.open({
        type: 'success',
        message: 'Deleted Stock Transfer successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: st?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(STActions.deleteStLoading(false));
  } catch (error) {
    yield put(STActions.deleteStLoading(false));
    yield put(TrackerActions.trackAction(stActionTypes.DELETE_ST.ERROR, error));
  }
}

/**
 *
 */
function* deleteSt() {
  yield takeLatest(stActionTypes.DELETE_ST.REQUEST, _deleteSt);
}

/**
 *
 */

function* createStShortClose(action) {
  try {
    yield put(STActions.createStShortCloseLoading(true));
    const st = yield STService.createStShortClose(action.payload);
    if (st.success) {
      yield put(TrackerActions.trackAction(stActionTypes.ST_SHORT_CLOSE.SUCCESS, st.data));
      notification.open({
        type: 'success',
        message: 'Stock transfer short close created successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: st?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(STActions.createStShortCloseLoading(false));
  } catch (error) {
    yield put(STActions.createStShortCloseLoading(false));
    yield put(TrackerActions.trackAction(stActionTypes.ST_SHORT_CLOSE.ERROR, error));
  }
}

/**
 *
 */

function* stShortClose() {
  yield takeLatest(stActionTypes.ST_SHORT_CLOSE.REQUEST, createStShortClose);
}

function* _updateSTWorkflowStep(action) {
  try {
    yield put(STActions.updateSTWorkflowStepLoading(true));
    const { payload } = action;
    const stockTransfer = yield STService.updateSTWorkflowStep(payload);
    if (stockTransfer.success) {
      notification.open({
        type: 'success',
        message: 'StockTransfer approval status updated successfully',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(stockTransfer);
      }
    } else {
      notification.open({
        type: 'error',
        message: stockTransfer.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(STActions.updateSTWorkflowStepLoading(false));
  } catch (error) {
    yield put(STActions.updateSTWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(STActions.trackAction(stActionTypes.UPDATE_ST_WORKFLOW_STEP.ERROR, error));
  }
}

/**
 *
 */
function* updateSTWorkflowStep() {
  yield takeLatest(stActionTypes.UPDATE_ST_WORKFLOW_STEP.REQUEST, _updateSTWorkflowStep);
}

export default function* productSaga() {
  yield all([
    updateStStatus(),
    createSt(),
    getSt(),
    getStById(),
    updateSt(),
    deleteSt(),
    stShortClose(),
    updateSTWorkflowStep(),
  ]);
}
